<template>
  <div class="callme_total_wrap">
    <div class="callme_bottom_wrap">
      <div class="bottom_container">
        <div class="left">
          <div class="items_wrap">
            <img v-if="config && config.logo1" :src="config.logo1" class="footerImg" @click="handleGoHome"/>
          </div>
          <div class="items_wrap">
            <div class="item_options">
              <div @click="handleLocation(bottomText[0])" class="optionDiv" v-if="bottomText && bottomText.length > 0 && bottomText[0]">{{ bottomText[0].text }}</div>
              <div @click="handleLocation(bottomText[1])" class="optionDiv" v-if="bottomText && bottomText.length > 0 && bottomText[1]">{{ bottomText[1].text }}</div>
              <div @click="handleLocation(bottomText[2])" class="optionDiv" v-if="bottomText && bottomText.length > 0 && bottomText[2]">{{ bottomText[2].text }}</div>
            </div>
          </div>
          <div class="divider-vertical" />
          <div class="items_wrap">
            <div class="item_options">
              <div @click="handleLocation(bottomText[3])" class="optionDiv" v-if="bottomText[3]">{{ bottomText[3].text }}</div>
              <div @click="handleLocation(bottomText[4])" class="optionDiv" v-if="bottomText[4]">{{ bottomText[4].text }}</div>
              <div @click="handleLocation(bottomText[5])" class="optionDiv" v-if="bottomText[5]">{{ bottomText[5].text }}</div>
            </div>
          </div>
          <div class="divider-vertical" />
          <div class="items_wrap">
            <div class="item_options">
              <div @click="handleLocation(bottomText[6])" class="optionDiv" v-if="bottomText[6]">{{ bottomText[6].text }}</div>
              <div @click="handleLocation(bottomText[7])" class="optionDiv" v-if="bottomText[7]">{{ bottomText[7].text }}</div>
              <div @click="handleLocation(bottomText[8])" class="optionDiv" v-if="bottomText[8]">{{ bottomText[8].text }}</div>
            </div>
          </div>
        </div>
        <div class="right" :class="{ 'mobile-layout': platform === 'mobile' }">
          <div class="items_wrap" :class="{ w100: platform === 'mobile' }">
            <div class="item_options" style="margin-left: 0">
              <div class="item_tit">实时动态与信息，关注我们</div>
              <div class="item_icon">
                <el-popover v-for="item in list" :key="item.id" placement="top" trigger="hover">
                  <img slot="reference" class="icon" :src="item.icon" @click="handleJump(item)"/>
                  <div style="text-align: center">
                    <img width="200px" height="200px" v-for="(key, idx) in item.images.split(',')" :key="idx" :src="key" />
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
          <div class="items_wrap" :class="{ w100: platform == 'mobile' }">
            <div class="item_tit">
              <img src="@/assets/images/slogan2.png" width="220" />
            </div>
            <div class="item_ewm">
              <div class="" style="display: flex;padding-left: 10px;">
                <img :src="bottomQrcode" alt="">
                <img :src="bottomQrcode2" alt="" style="margin-left: 5px;">
              </div>
              <!-- <div class="" v-for="item in list" :key="item.id">
                <img v-if="item.title == '微信'" :src="item.images.split(',')[0]" />
                <img v-else-if="item.title == '微博'" :src="item.images" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="navigate_wrap" v-if="config && Object.keys(config).length > 0">
        <div style="flex-shrink: 0;">
          <div>Copyright 2014 owecn.com All Rights Reserved </div>
          <span>{{ config.copyright || '' }}</span>
        </div>
        <div class="footer-link" style="flex-shrink: 0;">
          <a class="p" style="text-align: center;cursor: pointer;" @click="showDialog('yhxz')">用户协议</a>
          <a class="p" style="text-align: center;cursor: pointer;" @click="showDialog('yszc')">隐私协议</a>
          <a class="p" v-if="config.icp" href="https://beian.miit.gov.cn/" target="_blank">{{ config.icp }}</a>
          <a class="p" v-if="config.gawbah && gawbah" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${gawbah}`" target="_blank">{{ config.gawbah }}</a>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" :width="platform == 'web' ? '500px' : '100%'" center append-to-body>
      <div v-html="dialogContent"></div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="btn default" @click="dialogVisible = false">取消</el-button>
          <el-button class="btn comfirm" @click="dialogVisible = false">我已阅读并同意</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      activeIndex: "1",
      showCity: 0,
      bottomText: [],
      bottomQrcode: '',
      bottomQrcode2: '',
      dialogTitle: '',
      dialogVisible: false,
      dialogContent: ''
    };
  },
  computed: {
    ...mapState(["config", "platform"]),
    gawbah() {
      if (!this.config.gawbah) return '';
      const str = this.config.gawbah.split(" ")[1];
      const num = str.slice(0, str.length - 1);
      return num;
    },
  },
  watch: {
    config: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.initFooterData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getList();
    this.initFooterData();
  },
  methods: {
    initFooterData() {
      if (this.config && Object.keys(this.config).length > 0) {
        this.bottomText = this.config.bottom_text || [];
        this.bottomQrcode = this.config.bottom_qrcode || '';
        this.bottomQrcode2 = this.config.bottom_qrcode2 || '';
      }
    },
    showDialog(name) {
      this.dialogTitle = name === "yhxz" ? "用户协议" : "隐私政策";
      this.dialogVisible = true;
      this.dialogContent = name === "yhxz" ? this.config.yonghuxieyi : this.config.yinsizhengce;
    },
    handleLocation(location) {
      if (location.url) {
        window.location.href = location.url;
      }
    },
    async getList() {
      const res = await CifuAPI.getBottomIcons();
      this.list = res.data;
      console.log(this.list)
    },
    handleSelect(index) {
      this.showCity = parseInt(index) - 1;
    },
    handleToRouter(url) {
      this.$router.replace(url);
    },
    handleGoHome() {
      this.$router.replace("/");
    },
    // 跳转外链
    handleJump(item) {
      if (item.jump_url) {
        window.location.href = item.jump_url
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  min-width: 1400px; // 设置合理的固定宽度，防止过度缩小 // 电脑端最小宽度
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  
  .callme_bottom_wrap {
    width: 100%;
    min-width: 1200px;
    background: #d60c18;
    color: #fff;
    .bottom_container {
      width: 1200px; // 设置合理的固定宽度，防止过度缩小
      padding: 80px 0;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // 处理浏览器放大后的情况
      @media screen and (min-width: 1201px) {
        min-width: auto; // 1200px以上恢复完全响应式
      }
      .left,
      .right {
        display: flex;
      }
      img {
        vertical-align: top;
        flex-shrink: 0;
      }
      .items_wrap {
        .item_tit {
          font-size: 22px;
        }
        .item_options {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          margin: 0 24px;
          
          @media screen and (min-width: 1200px) and (max-width: 1600px) {
            margin: 0 30px;
          }
          
          .optionDiv {
            font-size: 16px;
            margin-bottom: 1.5rem;
            white-space: nowrap;
            text-align: center;
            cursor: pointer;
            &:last-child {
              margin-bottom: 0;
            }
          }
          
          img {
            width: 100%;
            flex-shrink: 0;
            margin-top: 20px;
          }
        }
        
        .item_icon {
          padding-top: 50px;
          display: flex;
          gap: 20px;
          .icon {
            width: 41px;
            height: 41px;
            flex-shrink: 0;
            margin-top: 0;
            margin-right: 0;
          }
          
          .ewm {
            width: 200px;
            height: 200px;
          }
        }
        
        .item_ewm {
          display: flex;
          justify-content: space-between;
          padding-top: 10px;
          
          img {
            width: 100px;
            flex-shrink: 0;
            height: 100px;
            margin-bottom: 0;
          }
        }
      }
      
      .w100 {
        width: 100%;
        padding-top: 20px;
        
        .item_options {
          width: 100%;
          margin: 0;
        }
        
        img {
          width: 100%;
          margin-right: 0;
        }
      }
      
      .divider-vertical {
        align-items: stretch;
        width: 1px;
        margin: 0 5px;
        background-color: #fff;
      }
    }
    
    .navigate_wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      min-width: 1400px; // 设置合理的固定宽度，防止过度缩小
      height: 100px;
      padding: 0 260px;
      background-color: #fff;
      color: #333;
      // 处理浏览器放大后的情况
      @media screen and (min-width: 1401px) {
        min-width: auto; // 1200px以上恢复完全响应式
      }
      a {
        color: initial;
        font-size: 16px;
        text-decoration: none;
        
        // @media screen and (max-width: 768px) {
        //   font-size: 14px;
        // }
      }
      span {
        padding-right: 10px;
        font-size: 18px;
        margin-right: 0;
        flex-shrink: 0;
        // @media screen and (max-width: 768px) {
        //   display: block;
        //   padding: 0;
        //   margin-right: 0;
        //   margin-bottom: 10px;
        //   font-size: 14px;
        // }
      }
      p {
        font-size: 16px;
        
        // @media screen and (max-width: 768px) {
        //   font-size: 14px;
        // }
      }
    }
  }
}

.footerImg {
  width: 107px;
}
::v-deep .article img{
  width: 100% !important;
}
::v-deep .content img{
  width: 100% !important;
}
::v-deep .about-content img {
  width: 100% !important;
}
.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 41px;
  line-height: 0;
  border-radius: 40px;
  border-color: #fbce00;
  font-size: 18px;
  color: #663301;
}
.default {
  background-color: #fff;
}
.comfirm {
  background: #fbce00;
}
</style>
